import { render } from "./ProjectSmetaRestore.vue?vue&type=template&id=2a1a9629&scoped=true"
import script from "./ProjectSmetaRestore.vue?vue&type=script&lang=js"
export * from "./ProjectSmetaRestore.vue?vue&type=script&lang=js"

import "./ProjectSmetaRestore.vue?vue&type=style&index=0&id=2a1a9629&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1a9629"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QSpinner});
